module.exports = __webpack_public_path__ + "img/img_cmag1.d2d1db4f.png";